import Cookies from 'universal-cookie';
import { END_POINT_URL } from 'config/env.conf';
import axios from 'axios';
const cookies = new Cookies();

export function downloadFile(systemName, fileId) {
  const isAuth = cookies.get('userInfo');
  const url = `${END_POINT_URL}/file/${systemName}/download/${fileId}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${isAuth.token}`,
    },
  });
}

export function downloadFileFromUrl(url) {
  const isAuth = cookies.get('userInfo');
  return axios.get(url, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${isAuth.token}`,
    },
  });  
}
